import * as React from 'react';

function SvgUpdateListing(props) {
  return (
    <svg
      width={156}
      height={120}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="update-listing_svg__a" d="M0 0h160v160H0z" />
      </defs>
      <g transform="translate(-2 -23)" fill="none" fillRule="evenodd">
        <mask id="update-listing_svg__b" fill="#fff">
          <use xlinkHref="#update-listing_svg__a" />
        </mask>
        <g mask="url(#update-listing_svg__b)">
          <g transform="translate(-1 20)">
            <path
              d="M137.042 122.318L77.11 109.659a7.943 7.943 0 01-6.13-9.413l9.892-46.84 75.477 15.941-9.893 46.84a7.943 7.943 0 01-9.414 6.13"
              fill="#FFF"
            />
            <path
              fill="#C8C9CB"
              d="M128.682 113.302l.532.113 8.883-42.06 9.412 1.988-8.77 41.527-9.945-2.1-.112.532.532.113-.532-.113-.113.533 11.01 2.326 9.221-43.658-11.543-2.438-9.22 43.658.532.112.113-.533"
            />
            <path
              fill="#C8C9CB"
              d="M139.159 115.516l.113-.533-61.11-12.907 8.77-41.527 60.577 12.794-8.883 42.06.533.113.113-.533-.113.533.532.112 9.11-43.125-62.709-13.245-9.22 43.658 62.707 13.245.112-.533-.532-.112"
            />
            <path
              fill="#C8C9CB"
              d="M145.942 83.401l.113-.533-61.11-12.907 1.987-9.412 60.577 12.794-2.1 9.946.533.112.113-.533-.113.533.532.113 2.326-11.01-62.708-13.246-2.438 11.544 62.708 13.245.112-.533-.532-.113m-4.508 21.341l.113-.532-61.11-12.908 1.988-9.412 60.577 12.795-2.1 9.945.532.112.113-.532-.113.532.533.113 2.326-11.011-62.709-13.245-2.437 11.544 62.707 13.244.113-.532-.533-.113"
            />
            <path
              fill="#C8C9CB"
              d="M108.323 109.002l.533.112 8.883-42.058 9.413 1.987-8.771 41.527-9.945-2.1-.113.532.533.112-.533-.112-.112.533 11.01 2.325 9.222-43.657-11.544-2.438-9.221 43.657.533.113.112-.533m-20.41-4.31l.533.112 8.883-42.06 9.412 1.989-8.77 41.526-9.945-2.1-.112.533.532.112-.532-.112-.113.532 11.01 2.326 9.22-43.658-11.543-2.438-9.22 43.657.533.113.113-.532"
            />
            <path
              d="M156.35 69.347L80.871 53.405l2.003-9.482a4.255 4.255 0 015.042-3.284l67.152 14.183a4.255 4.255 0 013.283 5.042l-2.003 9.483"
              fill="#38B2A6"
            />
            <path
              d="M150.401 59.301a2.688 2.688 0 11-5.26-1.11 2.688 2.688 0 015.26 1.11"
              fill="#2B948A"
            />
            <path
              d="M146.677 57.642l1.28-6.06a1.298 1.298 0 112.54.537l-1.28 6.06a1.299 1.299 0 01-2.54-.537z"
              fill="#E2F4F2"
            />
            <path
              d="M95.305 47.664a2.69 2.69 0 11-5.263-1.112 2.69 2.69 0 015.263 1.112"
              fill="#2B948A"
            />
            <path
              d="M91.58 46.005l1.28-6.06a1.297 1.297 0 112.54.537l-1.28 6.06a1.297 1.297 0 11-2.54-.537z"
              fill="#E2F4F2"
            />
            <path
              d="M109.286 50.617a2.69 2.69 0 11-5.262-1.112 2.69 2.69 0 015.262 1.112"
              fill="#2B948A"
            />
            <path
              d="M105.562 48.958l1.28-6.06a1.298 1.298 0 112.54.538l-1.28 6.059a1.298 1.298 0 01-2.54-.537z"
              fill="#E2F4F2"
            />
            <path
              d="M136.84 56.437a2.688 2.688 0 11-5.262-1.111 2.69 2.69 0 015.262 1.111"
              fill="#2B948A"
            />
            <path
              d="M133.116 54.778l1.28-6.06a1.298 1.298 0 112.54.537l-1.28 6.06a1.298 1.298 0 01-2.54-.537z"
              fill="#E2F4F2"
            />
            <path
              d="M142.448 88.403a3.088 3.088 0 11-6.041-1.277 3.088 3.088 0 016.041 1.277"
              fill="#FCCE01"
            />
            <path
              d="M138.066 109.782l-.266-.056a2.815 2.815 0 11-5.51-1.162 2.815 2.815 0 015.51 1.162l.266.056.267.057a3.36 3.36 0 10-6.574-1.387 3.36 3.36 0 006.574 1.387l-.267-.057"
              fill="#38B2A6"
            />
            <path
              d="M22.993 42.125c1.91 5.25-.797 11.054-6.046 12.965-5.25 1.91-11.055-.796-12.965-6.046-1.911-5.25.796-11.054 6.045-12.964 5.25-1.911 11.055.795 12.966 6.045"
              fill="#F9A600"
            />
            <path
              d="M18.125 46.376c.057.334.106.63.144.885.038.257.085.521.14.793.058.272.1.515.129.73-.265.207-.485.36-.659.461-.172.1-.374.193-.604.276a6.3 6.3 0 01-1.124.293 14.54 14.54 0 01-1.232.148c-.43.034-.74.068-.932.1a3.412 3.412 0 00-.604.163 4.219 4.219 0 00-1.08.58c-.136.105-.244.2-.324.284-.08.084-.179.202-.298.356l-.15-.516a15.901 15.901 0 00-.191-.628l-.266-.833c.165-.125.29-.24.378-.344.087-.104.154-.235.202-.393.048-.157.068-.34.06-.547a1.97 1.97 0 00-.118-.602 3.446 3.446 0 00-.105-.247c-.539.211-1.037.415-1.496.612a41.71 41.71 0 00-.2-1.078c-.077-.38-.136-.698-.178-.952l.287-.097c.093-.034.207-.078.342-.132a7.048 7.048 0 01-.19-.232l-.219-.272a4.881 4.881 0 01-.141-.204 1.58 1.58 0 01-.097-.174 2.324 2.324 0 01-.188-1.402c.07-.42.256-.823.559-1.205a3.592 3.592 0 011.062-.916 9.285 9.285 0 011.37-.618c.34-.124.685-.233 1.035-.329.35-.095.81-.191 1.38-.288.119.312.436 1.04.952 2.182-.532-.007-.965.007-1.298.04a3.783 3.783 0 00-.916.203c-.42.153-.728.365-.924.636-.196.272-.242.553-.136.843.03.082.07.16.12.235.049.074.114.164.196.27.08.107.135.186.164.237l.318-.115c.526-.204.995-.393 1.407-.566l1.081-.43c.033.253.084.565.153.935.07.37.134.751.192 1.145-.339.113-.62.211-.846.293l-1.338.487.125.425c.042.144.07.25.085.316a1.324 1.324 0 01.024.408c-.005.074-.018.215-.037.423a6.772 6.772 0 00.967-.176c.186-.046.376-.09.568-.132.192-.042.315-.07.37-.086.098-.03.218-.072.36-.123.37-.135.696-.3.975-.494.28-.194.53-.404.746-.628"
              fill="#FFF"
            />
            <path fill="#FCFBFC" d="M34.444 93.492h89.795V20.698H34.444z" />
            <path
              d="M34.444 20.65h89.795a6.807 6.807 0 00-6.807-6.807h-76.18a6.807 6.807 0 00-6.808 6.807z"
              fill="#3A3B39"
            />
            <path
              d="M47.612 17.023a1.197 1.197 0 11-2.394 0 1.197 1.197 0 012.394 0m4.936 0a1.197 1.197 0 11-2.395 0 1.197 1.197 0 012.395 0"
              fill="#B5B7B4"
            />
            <path
              d="M42.678 17.023a1.197 1.197 0 11-2.395 0 1.197 1.197 0 012.395 0"
              fill="#E05E55"
            />
            <path
              fill="#EBE9E5"
              d="M114.583 67.192l-70.113.02-.001-3.551 70.113-.022v3.553m0 8.027l-70.111.031-.002-3.543 70.113-.03v3.542m-46.89 8.06l-23.222.01-.001-3.562 23.221-.01.001 3.562m28.582 0l-23.222.01v-3.562l23.221-.01v3.562"
            />
            <circle fill="#38B2A6" cx={81.167} cy={43.318} r={13.398} />
            <path
              d="M74.72 42.204l5.967-5.394a.69.69 0 01.953 0l2.96 2.673v-.477c0-.175.135-.318.298-.318h.819c.163 0 .297.143.297.318v1.766l1.593 1.432a.82.82 0 01.089 1.098.699.699 0 01-1.027.095l-.09-.08v6.206c0 .27-.208.493-.46.493H82.71v-5.744h-3.065v5.744h-3.408c-.253 0-.461-.223-.461-.493v-6.205l-.09.08a.7.7 0 01-.476.19.748.748 0 01-.565-.27c-.268-.35-.224-.844.073-1.114"
              fill="#FFF"
            />
            <path
              d="M157.204 17.06c-1.668 5.818-7.736 9.182-13.554 7.514-5.818-1.669-9.182-7.737-7.513-13.554 1.668-5.818 7.736-9.182 13.554-7.514 5.817 1.669 9.182 7.737 7.513 13.555"
              fill="#F9A600"
            />
            <path
              d="M142.657 15.082c.418.353.814.636 1.187.849.373.213.704.36.993.444.254.073.49.073.707 0a.618.618 0 00.42-.44.81.81 0 00.019-.343 1.572 1.572 0 00-.064-.22 1.457 1.457 0 00-.09-.213c-.028-.05-.14-.247-.34-.59-.565-.982-.933-1.667-1.103-2.054a2.9 2.9 0 01-.231-.952 2.66 2.66 0 01.088-.931 2.36 2.36 0 01.29-.635c.128-.199.284-.378.467-.537a2.648 2.648 0 011.308-.613c.242-.039.588-.052 1.04-.04.055-.153.086-.244.095-.274l.13-.48.24-.836c.53.163.972.295 1.324.396.392.112.833.234 1.326.364-.18.536-.284.85-.31.944l-.182.631a11.4 11.4 0 011.345.711c-.193.801-.38 1.634-.565 2.5a6.167 6.167 0 00-.986-.704 3.951 3.951 0 00-.8-.356c-.25-.072-.473-.073-.67-.006a.543.543 0 00-.373.374.787.787 0 00.017.482c.056.164.148.355.277.572.465.78.797 1.39.995 1.834.199.444.313.844.344 1.199a2.754 2.754 0 01-.397 1.705c-.132.21-.289.39-.472.545a2.85 2.85 0 01-.587.387c-.21.105-.418.185-.625.242a6.13 6.13 0 01-.886.152l-.282.928a55.56 55.56 0 00-.25.898c-.53-.163-.952-.29-1.265-.38-.313-.09-.777-.217-1.392-.382.123-.336.26-.766.41-1.29l.086-.3a13.287 13.287 0 01-.947-.454 10.76 10.76 0 01-.9-.56c.318-1.239.521-2.094.61-2.567"
              fill="#FFF"
            />
            <g>
              <path
                d="M55.548 102.154c.171 1.218-.754 2.356-2.066 2.54l-23.366 3.284c-1.312.185-2.515-.654-2.687-1.872L21.72 65.47c-.172-1.218.754-2.356 2.066-2.54l23.366-3.284c1.312-.185 2.515.654 2.686 1.873l5.711 40.635"
                fill="#3A3B39"
              />
              <path fill="#FEDA2E" d="M48.544 101.039l5.13-.721L52.05 88.75l-5.13.72z" />
              <path fill="#FFFFFE" d="M24.844 76.21l24.95-3.507-1.378-9.802-24.95 3.506z" />
              <path
                fill="#52CCC0"
                d="M26.018 84.566l5.131-.721-.72-5.13-5.132.721zm6.607-.928l5.13-.721-.72-5.13-5.131.72zm6.606-.929l5.13-.72-.72-5.13-5.131.72zm6.606-.928l5.131-.721-.721-5.13-5.13.72z"
              />
              <path
                fill="#FFFFFE"
                d="M26.916 90.952l5.13-.72-.72-5.131-5.131.72zm6.606-.928l5.13-.721-.72-5.13-5.131.72zm6.606-.929l5.131-.72-.721-5.131-5.13.72zm6.607-.928l5.13-.721-.72-5.13-5.131.72zm-18.915 9.22l5.131-.72-.72-5.13-5.132.72zm6.607-.928l5.13-.72-.72-5.131-5.132.72zm6.606-.928l5.13-.721-.72-5.13-5.131.72zm-12.308 8.293l5.13-.721-.72-5.131-5.131.72zm6.606-.928l5.13-.721-.72-5.132-5.131.721zm6.606-.929l5.131-.72-.721-5.132-5.13.721z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgUpdateListing;
